import { NgRedux, select } from "@angular-redux/store";
import { Component, ElementRef, OnChanges, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs/Rx";
import { MsalService } from "../../../msal/msal.service";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";
import { ContainerStatusId } from "../../../pb-screen/models/planning-block/planning-block-container-status.interface";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { IdNameAsStringObject } from "../../../pb-screen/models/quick-view/id-name-as-string-object.interface";

import { PoolService } from "../../../pool/pool.service";
import { LocationSelectorComponent } from "../../../shared/components/location-selector/location-selector.component";
import { AddressLocation } from "../../../shared/models/address-location";
import { ComponentSource } from "../../../shared/models/component-source";
import { UpdatePlanningBlock } from "../../../shared/models/planning-block/update-planning-block.interface";
import { ModalType } from "../../../shared/models/source";
import {
  ON_HOLD,
  PLANNED,
  PlanningStatusDisplay,
  PRE_PLANNED,
  RE_USED,
  TO_BE_PLANNED,
  CREATED
} from "../../../shared/models/status-type.interface";
import { ActionBarService } from "../../../shared/services/action-bar.service";
import { ModalManagerService } from "../../../shared/services/modal-manager.service";
import { SharedService } from "../../../shared/services/shared.service";
import { SharedActions } from "../../../shared/shared.actions";
import { IAppState } from "../../../store/IAppState";
import { DepotInActions } from "../../depot-in.actions";
import { SimpleModalComponent } from "ngx-simple-modal";
import { takeUntil } from "rxjs/operators";
import { UserFeedbackService } from "../../../services/user-feedback.service";
import * as moment from "moment";



@Component({
  selector: "depot-in-status-modal",
  templateUrl: "./depot-in-status-modal.component.html",
})

export class DepotInStatusModalComponent extends SimpleModalComponent<void, void> implements OnChanges, OnInit, OnDestroy {

  @select("depotInSelection") public depotInSelection$: Observable<PlanningBlock[]>;
  @select("depotOutSelection") public depotOutSelection$: Observable<PlanningBlock[]>;
  @select("applicationUser") applicationUser$: Observable<ApplicationUser>;
  @select("containerStatuses") public containerStatuses$: Observable<IdNameAsStringObject[]>;
  @select("loading") public loading$: Observable<boolean>;
  @ViewChild(LocationSelectorComponent) private locationSelector: LocationSelectorComponent;

  public enableAutocomplete: boolean = false;
  public selectedPlanningBlocks: PlanningBlock[] = [];
  public depotOutSelection: PlanningBlock[] = [];
  public selectedLocation: AddressLocation;
  public selectedPbsStatus: string;
  public selectedStatus: IdNameAsStringObject;
  public componentSource = ComponentSource;
  public containerStatusId = ContainerStatusId;
  public statusOptions: IdNameAsStringObject[] = [];
  public containerStatuses: IdNameAsStringObject[] = [];
  public containerNumberIsValid: boolean = true;
  public containerNumberRequired: boolean = false;
  public containerNumber: string;
  public containerNumberErrorMessage: string;
  public buttonState: boolean = true;
  public depotInFrom: string;
  public depotInFromRequired: boolean = false;
  public commentEnabled: boolean = false;
  public ref1Enabled: boolean = false;
  public ref2Enabled: boolean = false;
  public statusEnabled: boolean = false;
  public commentValue: string = "";
  public ref1Value: string = "";
  public ref2Value: string = "";
  public updatedPlanningBlocks: PlanningBlock[] = [];
  public modalType = ModalType;
  public containerNumberFilled: boolean = false;
  public locationFilled: boolean = true;
  public loading: boolean = false;
  public enabled: boolean = false;
  public bookedFromValue: string = "";
  public bookedUntilValue: string = "";
  public containerIsAvailable: boolean = false;
  public warehouseRemark: string = "";
  public CONTAINER_NUMBER_LENGTH: number = 11;
  public userId: string = "";
  public locationWasUpdated = false;
  private readonly destroy$ = new Subject<void>();


  public selectedPlanningState;
  public planningStates: any[] = [PlanningStatusDisplay.onHold, PlanningStatusDisplay.toBePlanned];
  public allowPlanningStateChange: boolean = false;

  user: ApplicationUser;
  locationRequired: boolean = false;

  public emptyLocation: AddressLocation = {
    timestamp: "",
    addressId: "",
    locationCode: "",
    searchName: "",
    createdBy: "",
    creationDateTime: "",
    lastModifiedBy: "",
    lastModificationDateTime: "",
  };

  constructor(
    private readonly sharedService: SharedService,
    private readonly sharedActions: SharedActions,
    private readonly ngRedux: NgRedux<IAppState>,
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService,
    private readonly poolService: PoolService,
    private readonly depotInActions: DepotInActions,
    private readonly actionBarService: ActionBarService,
    private readonly modalManager: ModalManagerService,
    private readonly authService: MsalService,
    private readonly userFeedbackService: UserFeedbackService
  ) {
    super();
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public ngOnInit(): void {

    const account = this.authService.getAccount();
    this.userId = account.username;


    this.loading$.subscribe((data) => {
      if (!data) {
        this.loading = data;
      }
    });

    this.applicationUser$.subscribe((user) => {
      if (user !== null) {
        this.user = user;
        this.locationRequired = this.user.generalSetting.locationRequired;
        this.enableAutocomplete = user.generalSetting.enableAutocomplete;
      }
    });


  }

  public ngAfterViewInit() {
    this.depotOutSelection$.pipe(takeUntil(this.destroy$)).subscribe((selectedDepotOutPlanningBlocks: PlanningBlock[]) => {
     this.depotOutSelection = selectedDepotOutPlanningBlocks;

    });

    this.depotInSelection$.pipe(takeUntil(this.destroy$)).subscribe((selectedPlanningBlocks: PlanningBlock[]) => {
          if(selectedPlanningBlocks.length > 0) {
          var selectedPlanningBlocksIds = selectedPlanningBlocks.map((pb) => pb.id);
          this.loading = true; 
          this.sharedService.getPlanningBlocksByIds(selectedPlanningBlocksIds).subscribe((planningBlocks: PlanningBlock[]) => {
            this.selectedPlanningBlocks = planningBlocks;
            this.loading = false;
            this.setModalFields(this.selectedPlanningBlocks);
          }, (error) => {
            this.userFeedbackService.showErrorMessage("SHARED.ERRORS.REFRESH_PLANNING_BLOCKS" + "." + error);
            this.loading = false;
          });
        }
    });

    this.containerStatuses$.pipe(takeUntil(this.destroy$)).subscribe((statuses: IdNameAsStringObject[]) => {
      this.statusOptions = statuses;
      this.containerStatuses = statuses;
       
    });

    this.depotInFrom = new Date().toISOString().slice(0, 10);
    this.containerNumber = null;

  }

  public ngOnChanges() {
    this.setSelection();
  }

  public setModalFields(selectedPlanningBlocks: PlanningBlock[]) {
    this.updateFormValues(selectedPlanningBlocks);
    this.setSelection();
  }

  public setDateString(date: Date): string {

    return moment(date).local().format("YYYY-MM-DDTHH:mm:ss");

  }

  public reverseDateString(stringDate: string): string {
    let apiDate = "";
    if (stringDate) {
      // const allParts = stringDate.toString().split("T");
      // const dateParts = allParts[0].split("-");
      // apiDate += dateParts.reverse().join("/") + " " + allParts[1];

      return moment(stringDate).local().format("YYYY-MM-DDTHH:mm:ss");
    }
    return apiDate;
  }

  public setButtonState() {
    if (!this.containerNumberRequired) {
      this.containerNumberFilled = true;
    }
    if (this.containerNumberFilled && (this.locationFilled || !this.locationRequired)) {
      this.buttonState = true;
    } else {
      this.buttonState = false;
    }

    if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
      this.buttonState = true;
    }
  }

  public updateFormValues(selectedPlanningBlocks: PlanningBlock[]): void {
    if (selectedPlanningBlocks.length > 0) {
      this.selectedPbsStatus = selectedPlanningBlocks[0].containerStatus;
      this.getValidStatuses();

      this.containerNumber = null;
    
      this.statusEnabled =
        this.selectedPlanningBlocks
          .every((x) => x.containerStatus === this.selectedPlanningBlocks[0].containerStatus);
      this.enabled = this.selectedPlanningBlocks.length === 1;

      this.commentValue = this.selectedPlanningBlocks.every((x) =>
        x.planningBlockRemarks === this.selectedPlanningBlocks[0].planningBlockRemarks) ?
        this.selectedPlanningBlocks[0].planningBlockRemarks : "";
      this.commentEnabled = this.selectedPlanningBlocks.every((x) =>
        x.planningBlockRemarks === this.selectedPlanningBlocks[0].planningBlockRemarks);

      this.ref1Value = this.selectedPlanningBlocks.length === 1 ?
        selectedPlanningBlocks[0].depotInOrderLineRef1 : "";
      this.ref2Value = this.selectedPlanningBlocks.length === 1 ?
        selectedPlanningBlocks[0].depotInOrderLineRef2 : "";
      this.bookedFromValue = this.selectedPlanningBlocks.length === 1 ?
        this.setDateString(selectedPlanningBlocks[0].bookedDatetimeFrom) : "";
      this.bookedUntilValue = this.selectedPlanningBlocks.length === 1 ?
        this.setDateString(selectedPlanningBlocks[0].bookedDatetimeUntil) : "";
      this.warehouseRemark = selectedPlanningBlocks.length > 1 ? "" : selectedPlanningBlocks[0].warehouseRemark;
      this.setPlanningStateChange();
      this.locationWasUpdated = false;
      this.setButtonState();
    }
  }

  public setPlanningStateChange(): void {

    let firstStatus = this.selectedPlanningBlocks[0].status.statusType;
    this.allowPlanningStateChange = this.selectedPlanningBlocks.length > 0
      && this.selectedPlanningBlocks.every((x) => x.status.statusType == firstStatus)
      && (firstStatus !== RE_USED && firstStatus !== PLANNED);
    if (this.allowPlanningStateChange) {
      this.selectedPlanningState = this.planningStates.find((elem) => elem.value === this.selectedPlanningBlocks[0].status.statusType);
    } else {
      this.selectedPlanningState = null;
    }

  }

  public setPlanningBlockRemarks(selectedPlanningBlocks: PlanningBlock[]): any {
    if (selectedPlanningBlocks.length === 1) {
      this.commentValue = !this.commentValue ? selectedPlanningBlocks[0].planningBlockRemarks : this.commentValue;
      this.commentEnabled = true;
    } else {
      this.commentValue = selectedPlanningBlocks.every((x) =>
        x.planningBlockRemarks === selectedPlanningBlocks[0].planningBlockRemarks) ?
        selectedPlanningBlocks[0].planningBlockRemarks : "";
      this.commentEnabled = selectedPlanningBlocks.every((x) =>
        x.planningBlockRemarks === selectedPlanningBlocks[0].planningBlockRemarks);
    }
  }

  public onContainerInput(input: string) {
    if (this.selectedPlanningBlocks.length !== 0 && this.selectedPlanningBlocks[0].containerNo !== input && input.length === this.CONTAINER_NUMBER_LENGTH) {
      this.sharedService.checkContainerNumbersInFile(this.selectedPlanningBlocks[0].fileId, input).subscribe((res: boolean) => {
        if (!res) {
          this.userFeedbackService.showWarningMessage(
            "STATUS_MODAL.FILE_ALREADY_CONTAINS_CONTAINER_NUMBER",
            { fileId: this.selectedPlanningBlocks[0].fileId, containerNumber: input }
          );
        }
      });
    }
    if (this.containerNumber && this.containerNumber.length > 0 && (/\S/.test(input))) {
      this.containerNumberFilled = true;
      this.setButtonState();
    } else if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
      this.containerNumberFilled = true;
      this.setButtonState();
    } else {
      this.containerNumberFilled = false;
      this.setButtonState();
    }
  }

  public selectionChanged() {
    this.setSelection();
    if (this.selectedStatus?.name === this.selectedPbsStatus) {
      if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
        this.locationFilled = true;
      } else if (!this.locationSelector.selectedLocation) {
        this.locationFilled = false;
      }
      this.setButtonState();
    } else {
      if (this.locationSelector.selectedLocation
        && this.locationSelector.selectedLocation.searchName.length > 0) {
        this.locationFilled = true;
        this.setButtonState();
      } else {
        if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
          this.locationFilled = true;
        } else {
          this.locationFilled = false;
        }
        this.setButtonState();
      }
    }
  }

  public setSelection() {
    switch (this.selectedStatus?.id) {
      case ContainerStatusId.leegCrea:
        this.containerNumberRequired = true && (this.selectedPlanningBlocks.length === 1);
        this.depotInFromRequired = false;
        if (this.selectedPlanningBlocks.length === 1 && !this.containerNumber) {
          this.containerNumber = this.selectedPlanningBlocks[0].containerNo;
          this.onContainerInput(this.containerNumber);
        }
        break;
      case ContainerStatusId.leegAf:
        this.containerNumberRequired = true && (this.selectedPlanningBlocks.length === 1);
        this.depotInFromRequired = false;
        if (this.selectedPlanningBlocks.length === 1 && !this.containerNumber) {
          this.containerNumber = this.selectedPlanningBlocks[0].containerNo;
          this.onContainerInput(this.containerNumber);
        }
        break;
      case ContainerStatusId.geladen:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      case ContainerStatusId.volKlaar:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      case ContainerStatusId.volCrea:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      case ContainerStatusId.volAf:
        this.containerNumberRequired = false;
        this.depotInFromRequired = true;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      case ContainerStatusId.leegKlaar:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      case ContainerStatusId.volIn:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      case ContainerStatusId.gelost:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        break;
      default:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
    }
  }

  public setCurrentContainerNumberToSelectedPlanningBlockContainerNumber(): void {
    if (this.selectedPlanningBlocks.length === 1) {
      this.containerNumber = this.selectedPlanningBlocks[0].containerNo;
    }
  }

  public getValidStatuses() {
    if (this.selectedPbsStatus) {
      this.sharedService
        .getValidContainerStatuses(this.selectedPlanningBlocks[0].orderNumber, this.selectedPbsStatus)
        .subscribe((data: string[]) => {
          if (this.selectedPlanningBlocks[0]) {
            data.push(this.selectedPlanningBlocks[0].containerStatus);
            let array = this.containerStatuses.filter(status => data.find(el => el == status.name));
            this.statusOptions = array;
            this.selectedStatus = array.find(el => el.name == this.selectedPbsStatus);
            this.setSelection();


          }
        });
    }
  }

  public enableUi() {
    this.allowPlanningStateChange = false;
    this.setModalFields(this.selectedPlanningBlocks);
    this.sharedActions.setUiState(true);
    //this.modalManager.closeModal(this.modalType.status);

    this.close();
  }

  public getSelectedLocation(location: AddressLocation) {
    if (location) {
      if (this.selectedLocation !== location) {
        this.locationWasUpdated = true;
      }
      this.selectedLocation = location;
      if (this.locationSelector.selectedLocation
        && this.locationSelector.selectedLocation.searchName.length > 0) {
        this.locationFilled = true;
      } else {
        this.locationFilled = false;
      }
    } else {
      this.locationSelector.setSelectionFromParent("empty");
      this.selectedLocation = null;
      this.locationFilled = false;
    }
    this.setButtonState();
  }

  public clearLocation() {
    this.selectedLocation = null;
    this.locationSelector.setSelectionFromParent("empty");
    this.selectionChanged();
    this.setButtonState();
  }

  public updater() {
    if (this.containerNumberRequired && this.containerNumber && this.containerNumber.length !== 0) {
      this.checkContainerNumber();
    } else {
      this.updateDataNew(false);
    }
  }

  public checkContainerNumber() {
    this.sharedService.checkContainerNumberCpl(this.containerNumber, this.userId, this.selectedPlanningBlocks[0]).subscribe((res) => {
        if (res.statusCode === 200) {
          this.containerNumberIsValid = true;
          if (this.selectedPlanningBlocks[0].containerNo !== this.containerNumber) {
            this.checkContainerAvailability(this.selectedPlanningBlocks[0].id, this.containerNumber);
          } else {
            this.updateDataNew(false);
          }
        }
      },
      (err) => {
        this.containerNumberIsValid = false;
        this.buttonState = false;
        this.containerIsAvailable = false;
        this.translate.get("STATUS_MODAL.ERROR_PANEL.ERROR_TEXT").subscribe((res: string) => {
          this.containerNumberErrorMessage = res.split(":")[1];
          this.userFeedbackService.showErrorMessageWithoutTranslating(res);
        });
      });
  }

  public checkContainerAvailability(pbId: number, containerNumber: string) {
    this.containerNumberIsValid = true;
    this.poolService.checkContainerAvailability(this.selectedPlanningBlocks[0].id, this.containerNumber, this.userId)
      .subscribe((available: boolean) => {
        if (available) {
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.UPDATE_POOL_DEPOTIN");

        } else {
          // false: the user can carry on the normal function (update or plan)
          this.buttonState = true;
          this.updateDataNew(false);
        }
      }, (err) => {
        // display error , the user will have to type another c number
        this.buttonState = false;
        this.containerIsAvailable = false;
      });
  }

  public moveContainerOutOfPool() {
    this.poolService.registerApprovePoolContReqChecks([this.selectedPlanningBlocks[0].id], this.userId).subscribe(() => {
      this.updateDataNew(true);
    }, (err) => {
      // display error , the user will have to type another c number
      this.buttonState = true;
      this.containerIsAvailable = false;
    });
  }

  public updateDataNew(isMoveContainerOutOfPool: boolean) {
    this.loading = true;
    const toUpdatePlanningBlocks = this.selectedPlanningBlocks;
    const promises = [];

    toUpdatePlanningBlocks.forEach((planningBlock: PlanningBlock) => {
      promises.push(this.updatePlanningBlock(planningBlock, isMoveContainerOutOfPool, toUpdatePlanningBlocks.length,
        this.userId));
    });

    Promise.all(promises).then(() => {
      this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.STATUS_UPDATE_SUCCEEDED");
      this.resetUi();
      this.loading = false;
      this.containerIsAvailable = false;
    });

  }

  public updatePlanningBlock(planningBlock: PlanningBlock, isMoveContainerOutOfPool: boolean, numberOfPlanningBlocks: number,
                             username: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const updatePlanningBlockViewModel =
        this.getUpdatePlanningBlockViewModel(planningBlock, isMoveContainerOutOfPool, username);

      updatePlanningBlockViewModel.containerNumber.value = numberOfPlanningBlocks > 1
        ? planningBlock.containerNo : this.containerNumber;
      updatePlanningBlockViewModel.planningBlockRemark.value = numberOfPlanningBlocks > 1 && !this.commentEnabled
        ? planningBlock.planningBlockRemarks : this.commentValue;
      updatePlanningBlockViewModel.status = this.selectedPlanningState ? this.selectedPlanningState.value : -1;

      this.sharedService.updatePlanningBlockCpl(updatePlanningBlockViewModel)
        .subscribe((updatedPlanningBlocks: PlanningBlock) => {
          planningBlock.depotInFrom = this.formatDateForApi();
          planningBlock.containerNo = updatedPlanningBlocks.containerNumber;
          this.buttonState = true;
          this.containerIsAvailable = false;
          planningBlock.planningBlockRemarks = updatedPlanningBlocks.planningBlockRemarks;
          planningBlock.depotOutOrderLineRef1 = updatedPlanningBlocks.depotOutOrderLineRef1;
          planningBlock.depotOutOrderLineRef2 = updatedPlanningBlocks.depotOutOrderLineRef2;
          planningBlock.depotInOrderLineRef1 = updatedPlanningBlocks.depotInOrderLineRef1;
          planningBlock.depotInOrderLineRef2 = updatedPlanningBlocks.depotInOrderLineRef2;
          planningBlock.bookedDatetimeFrom = updatedPlanningBlocks.bookedDatetimeFrom
          planningBlock.bookedDatetimeUntil = updatedPlanningBlocks.bookedDatetimeUntil;

          this.sharedActions.updatePlanningBlocksDisplayCpl([updatedPlanningBlocks]);

          return resolve(true);
        }, (err) => {
          return resolve(false);
        });
    });
  }

  public getUpdatePlanningBlockViewModel(planningBlock: PlanningBlock,
                                         isMoveContainerOutOfPool: boolean,
                                         userId: string): UpdatePlanningBlock {
    let status: any;
    let location: any;

    if (this.statusEnabled) {
      status = this.selectedStatus?.name;
    } else {
      status = planningBlock.containerStatus;
    }

    if (!this.selectedLocation || !this.locationWasUpdated) {
      location = this.emptyLocation;
    } else {
      location = this.selectedLocation;
    }

    const updatePlanningBlock = {
      id: planningBlock.id,
      userId,
      bookedDates: {
        fromDateString: this.selectedPlanningBlocks.length == 1 ? this.reverseDateString(this.bookedFromValue) : moment(planningBlock.bookedDatetimeFrom).format("YYYY-MM-DDTHH:mm:ss"),
        untilDateString: this.selectedPlanningBlocks.length == 1 ? this.reverseDateString(this.bookedUntilValue) : moment(planningBlock.bookedDatetimeUntil).format("YYYY-MM-DDTHH:mm:ss"),
      },
      containerNumber: {
        value: this.containerNumber === null ? "" : this.containerNumber,
      },
      depotInDate: {
        value: this.formatDateForApi(),
      },
      depotInReference: {
        type: 0,
        value: this.ref1Value,
      },
      depotOutReference: {
        type: 0,
        value: "",
      },
      depotOutReference2: {
        type: 1,
        value: "",
      },
      depotInReference2: {
        type: 1,
        value: this.ref2Value,
      },
      status: this.selectedPlanningState ? this.selectedPlanningState.value : "",
      updateStatus: {
        addressLocation: location,
        status,
      },
      planningBlockRemark: {
        value: this.commentValue,
        remarkType: 5,
        orderId: "",
      },
      isMoveContainerOutOfPool,
      containerReuseNo: planningBlock.containerReuseNo,
      containerPoolRequestNo: planningBlock.containerPoolRequestNo,
    };

    return updatePlanningBlock;
  }

  public resetUi() {
    this.loading = false;
    this.setModalFields(this.selectedPlanningBlocks);
    this.depotInActions.setDepotInSelection([]);
    this.actionBarService.setActionBar([], this.depotOutSelection, ComponentSource.depotIn);
    this.sharedActions.setUiState(true);
    //this.modalManager.closeModal(this.modalType.status);
    this.close();


  }

  public resetContainerNumber() {
    this.containerNumber = null;
    this.containerNumberIsValid = true;
    this.containerNumberFilled = false;
    this.buttonState = false;
    this.containerIsAvailable = false;
  }

  public formatDateForApi() {
    //const dateArray = this.depotInFrom.split("-");
    //const apiFormattedDate = dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
    return this.depotInFrom;
  }

  public updateLocation() {
    if (this.locationSelector) {
      this.locationSelector.setSelectionFromParent(this.selectedPlanningBlocks[0].latestLocationCode);
      this.selectedLocation = this.locationSelector.selectedLocation;
      this.locationFilled = !!this.selectedLocation;
    }
  }
}
